import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms'

export function EmailDomainRestrictionValidator(domains: string[]): ValidatorFn {
    return (control:AbstractControl) : ValidationErrors | null => {

        let isValid: boolean
        const value : string = control.value as string

        //validating email format prior on checking domain.
        const emailRegex = new RegExp('^[\\w+-.]+@([\\w-]+\\.)+[\\w-]{2,4}$')

        if(!emailRegex.test(value)){
            return { email: true }
        }

        if (!value || (domains || []).length == 0 || control.status === 'INVALID') {
            return null
        }

        domains.forEach((v) => {
            if(value.endsWith(`@${v}`)){
                isValid = true
            }
        })

        return !isValid ? { restrictedEmail: true }: null
    }
}
